import Vue from 'vue'

export default {
    storeAlert(state, {name, alert}) {
        Vue.set(state.alerts, name, {...alert});
    },
    destroyAlert(state, alertName) {
        Vue.delete(state.alerts, alertName)
    },
};
